import QueueEpisodeCard from './QueueEpisodeCard';

export default QueueEpisodeCard;
